module.exports = __webpack_public_path__ + "static/media/DSA PRE I.4e23abae.png";